import React, { useState, useEffect, useRef, useMemo, forwardRef, useImperativeHandle } from 'react'
import { Image, Space, PreviewGroup, Modal, Form, Row, Col, Table, Input, Tag, Button } from '@bedrock/components'
import classNames from 'classnames/bind'
import _ from 'lodash'
import { useControllableValue, useMemoizedFn } from "ahooks";
import styles from './index.less'
import SFormElement from "@mpc/common/src/components/SForm/SFormElement";
import { Plus } from "@bedrock/icons-react";

const cx = classNames.bind(styles)

export type UserObj = {
  account: string,
  username: string,
  email: string,
  popo_account: string,
  status: 'ACTIVE' | 'LOCKED',
}

type UserlistProps = {
  view?: boolean,
  value?: UserObj[],
  onChange?: (value: UserObj[]) => void
}


const defaultUserObj = {
  account: "",
  username: "",
  email: "",
  popo_account: "",
  status: 'LOCKED',
}

const AccountTable = forwardRef(function (props: UserlistProps, ref) {
  const { view } = props
  const [dataList, setDataList] = useControllableValue<UserObj[]>(props, {
    defaultValue: [defaultUserObj]
  })

  const handleChange = (key, value, index) => {
    const newData = _.cloneDeep(dataList)
    newData[index][key] = value
    setDataList(newData)
  }

  useEffect(() => {
    !dataList && setDataList([])
  }, [dataList]);


  const renderColumns = useMemoizedFn(() => {
    let list = [
      {
        title: "登录账号",
        dataIndex: "mpc_no",
        key: "mpc_no",
        align: "left",
        width: 200,
        render: (value, array, index) => {
          return <div>{value}</div>
        }
      },
      {
        title: <span className={'span-required'}>用户名</span>,
        dataIndex: "username",
        key: "username",
        align: "left",
        render: (value, array, index) => {
          return <SFormElement
            componentClass="input"
            view={view}
            style={{ width: '100%' }}
            value={value}
            className={cx({ 'form-item-has-value': !!value })}
            onChange={(e) => {
              handleChange("username", e, index)
            }}
          />
        }
      },
      {
        title: <span className={'span-required'}>邮箱</span>,
        dataIndex: "email",
        key: "email",
        align: "left",
        render: (value, array, index) => {
          return <SFormElement
            componentClass="input"
            view={view}
            style={{ width: '100%' }}
            value={value}
            className={cx({ 'form-item-has-value': !!value })}
            onChange={(e) => {
              handleChange("email", e, index)
            }} />
        }
      },
      {
        title: "POPO账号",
        dataIndex: "popo_account",
        key: "popo_account",
        align: "left",
        render: (value, array, index) => {
          return <SFormElement
            componentClass="input"
            view={view}
            style={{ width: '100%' }}
            className={cx({ 'form-item-has-value': true })}
            value={value}
            onChange={(e) => {
              handleChange("popo_account", e, index)
            }} />
        }
      },
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        align: "left",
        width: 100,
        render: (value, array, index) => {
          const isAble = array.status === 'ACTIVE'

          if (view) {
            const color = isAble ? 'green' : 'red'
            return <Tag size={'small'} color={`light-${color}`} text={isAble ? '可用' : '不可用'} />
          }

          return <SFormElement
            componentClass="switch"
            view={view}
            value={isAble}
            onChange={(e) => {
              let status = e ? 'ACTIVE' : 'LOCKED'
              handleChange("status", status, index)
            }}
            labelOn={'可用'}
            labelOff={'关闭'}
          />
        }
      },
      {
        title: "操作",
        dataIndex: "action",
        key: "action",
        align: "left",
        width: 100,
        render: (value, array, index) => {
          return <Button type={"link"} onClick={() => remove(index)}>
            取消关联
          </Button>
        }
      },
    ]
    if (view) {
      list = list.filter(n => n.dataIndex !== "action")
    }
    return list
  })

  const add = useMemoizedFn(() => {
    const newData = _.cloneDeep(dataList) || []
    newData.push(defaultUserObj)
    setDataList(newData)
  });

  const remove = useMemoizedFn((index) => {
    const newData = _.cloneDeep(dataList) || []
    newData.splice(index, 1)
    setDataList(newData)
  });

  useImperativeHandle(ref, () => ({
    add,
    remove,
  }));


  return (<div style={{ width: "100%" }}>
    <Table
      className={cx("account-table")}
      columns={renderColumns()}
      rowKey={(record, index) => index}
      summary={pageDate => {
        if (view) return null
        return (
          <Table.Summary>
            <Table.Summary.Row>
              <Table.Summary.Cell index={0} colSpan={2}>
                <div
                  className={cx("add-account-btn")}
                  onClick={() => add()}
                >
                  <Plus /> <span>关联账号</span>
                </div>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={1} colSpan={view ? 3 : 4}>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )
      }}
      data={dataList || []}
    />
  </div>)
})


export default AccountTable